import React from 'react';
import { decl } from '@yandex-lego/i-bem-react';
import '@yandex-lego/i-ua';

import _pointerfocus from "./../pointerfocus/pointerfocus.react.js";

var PointerFocus = _pointerfocus.applyDecls();

export default decl({
    block: 'b-page',
    addMix: function addMix() {
        return {
            block: 'b-page', elem: 'body'
        };
    },
    content: function content() {
        return [React.createElement(PointerFocus, { key: 'pointerfocus' }), this.props.children];
    }
});